import React from "react";
import { LessonItemHeaderNavigator as CoreLessonItemHeaderNavigator } from "@jelly/lesson";

import defaultStyle from "./LessonItemHeaderNavigator.module.scss";

export const LessonItemHeaderNavigator: React.FC<React.ComponentProps<typeof CoreLessonItemHeaderNavigator>> = (
  props
) => {
  return <CoreLessonItemHeaderNavigator {...props} style={defaultStyle} />;
};
